import contact from "./contact.json";
import common  from "./common.json";
import blog    from "./blog.json";
import home    from "./home.json";
import hrm     from "./hrm.json";
import crm     from "./crm.json";
import pm      from "./pm.json";
import pms     from "./pms.json";
import erpMini from "./erpMini.json";
import dms     from "./dms.json";
import mes     from "./mes.json";
import tms     from "./tms.json";
import wms     from "./wms.json";
import eam     from "./eam.json";
import nav     from "./nav.json";
import footer  from "./footer.json";

export default {
  contact, common, blog, home, hrm, crm, pm, pms,
  erpMini, dms, mes, tms, wms, eam, nav, footer,
};
